import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { io } from 'socket.io-client';

const API_URL = import.meta.env.VITE_API_URL || '/api';
const SOCKET_URL = API_URL.replace('/api', '');

/**
 * Listens for jobs:updated socket events and invalidates the relevant
 * TanStack Query caches so all concurrent users see changes in real time.
 */
export function useJobsSync() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = io(SOCKET_URL, { transports: ['websocket', 'polling'] });

    socket.on('jobs:updated', ({ childName }: { childName: string }) => {
      queryClient.invalidateQueries({ queryKey: ['jobs', 'completed', childName] });
      queryClient.invalidateQueries({ queryKey: ['jobs', 'week-payment', childName] });
      queryClient.invalidateQueries({ queryKey: ['jobs', 'summary'] });
    });

    return () => {
      socket.close();
    };
  }, [queryClient]);
}
